import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface ProductAllergensProps {
  allergens?: string | null;
  hasDeclaration?: boolean | null;
}

export default function ProductAllergens({ allergens, hasDeclaration }: ProductAllergensProps): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <Box>
      <Typography variant="titleSmall" sx={{ mb: 1 }}>
        {t('products:allergen_list')}
      </Typography>
      <Typography variant="bodySmall">
        {hasDeclaration ? t('products:no_allergen') : allergens}
      </Typography>
    </Box>
  );
}
